import { FormGroup, FormParagraph } from '@ksyos/design-system';
import { FundingType } from '@common/enums';
import { getSelectedLanguage } from '@frontend/translate';
import type { AdminProcess, FundingExclusion } from '../adminProcessDetailsTypes';

type FundingSetToProps = {
    fundingExclusion?: FundingExclusion;
    fundingType: AdminProcess['fundingType'];
};

export function FundingSetTo({ fundingType, fundingExclusion }: FundingSetToProps) {
    const translate = getSelectedLanguage();

    const fundingTypeValue = fundingType || FundingType.freeOfCharge;

    if (fundingTypeValue !== FundingType.declareToInsurer && !fundingExclusion) {
        return null;
    }

    return (
        <FormGroup label={translate.request.fundingSetTo}>
            <FormParagraph>{translate.fundingType[fundingTypeValue]}</FormParagraph>
        </FormGroup>
    );
}
